import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box, Typography, Button } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
export default function ProtectedRoute(_a) {
    var _b;
    var children = _a.children, _c = _a.requireAdmin, requireAdmin = _c === void 0 ? false : _c;
    var _d = useAuth(), currentUser = _d.currentUser, loading = _d.loading, error = _d.error;
    var location = useLocation();
    if (loading) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 2,
                bgcolor: 'background.default'
            }, children: [_jsx(CircularProgress, { size: 40, thickness: 4 }), _jsx(Typography, { variant: "body1", color: "text.secondary", children: "Verifying authentication..." })] }));
    }
    if (error) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 2,
                p: 3,
                bgcolor: 'background.default'
            }, children: [_jsx(Typography, { variant: "h6", color: "error", gutterBottom: true, children: "Authentication Error" }), _jsx(Typography, { variant: "body1", color: "text.secondary", align: "center", children: error.message }), _jsx(Button, { variant: "contained", color: "primary", onClick: function () { return window.location.reload(); }, sx: { mt: 2 }, children: "Retry" })] }));
    }
    if (!currentUser) {
        // Redirect to authentication page with return URL
        return _jsx(Navigate, { to: "/auth", state: { from: location }, replace: true });
    }
    if (requireAdmin && !((_b = currentUser.email) === null || _b === void 0 ? void 0 : _b.endsWith('@geninvest.ai'))) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 2,
                p: 3
            }, children: [_jsx(Typography, { variant: "h6", color: "error", children: "Access Denied" }), _jsx(Typography, { variant: "body1", color: "text.secondary", align: "center", children: "This section requires administrative access." })] }));
    }
    return _jsx(_Fragment, { children: children });
}
